import { render, staticRenderFns } from "./PropertyHistory.vue?vue&type=template&id=74e9e136"
import script from "./PropertyHistory.vue?vue&type=script&lang=js"
export * from "./PropertyHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports